/**
 * Small helpers shared across Beauty pages.
 */
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

export function ScanRequiredEmpty({ title, desc }) {
  return (
    <div className="border border-dashed border-border p-10 lg:p-14 text-center" data-testid="beauty-scan-required">
      <Sparkles size={28} strokeWidth={1.4} className="mx-auto opacity-60" />
      <p className="font-serif text-2xl mt-4">{title || "Start with an AI Scan"}</p>
      <p className="text-sm text-muted-foreground mt-3 max-w-md mx-auto">
        {desc || "One selfie unlocks personalised makeup, hair and care recommendations across every Beauty module."}
      </p>
      <Link
        to="/beauty/scan"
        data-testid="beauty-scan-required-cta"
        className="mt-6 inline-flex items-center gap-2 bg-accent text-accent-foreground px-5 h-11 text-xs uppercase tracking-[0.2em]"
      >
        Run AI Scan <ArrowRight size={14} />
      </Link>
    </div>
  );
}

export function ScoreBar({ label, value, testId }) {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div data-testid={testId}>
      <div className="flex items-baseline justify-between">
        <p className="eyebrow">{label}</p>
        <p className="text-xs font-medium">{v}<span className="text-muted-foreground">/100</span></p>
      </div>
      <div className="h-1.5 bg-muted mt-2 relative overflow-hidden">
        <div className="absolute inset-y-0 left-0 bg-accent" style={{ width: `${v}%` }} />
      </div>
    </div>
  );
}

/** "Shop Recommended Products" button — always deep-links to Shop → For You */
export function ShopRecommendedButton({ category, concerns = [], label = "Shop Recommended Products", testId }) {
  const params = new URLSearchParams();
  params.set("tab", "foryou");
  params.set("category", category);
  if (concerns.length) params.set("concerns", concerns.join(","));
  return (
    <Link
      to={`/shop?${params.toString()}`}
      data-testid={testId || `shop-cta-${category}`}
      className="inline-flex items-center gap-2 border border-foreground px-4 h-10 text-[11px] uppercase tracking-[0.18em] hover:bg-accent hover:text-accent-foreground transition-colors"
    >
      {label} <ArrowRight size={13} />
    </Link>
  );
}

export function prettyEnum(v) {
  if (!v || v === "unknown") return "—";
  return String(v).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
